module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOrder),
      expression: "isOrder"
    }],
    on: {
      "listenEdit": _vm.showOrder
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "订单号/商品名称/手机号",
      "maxlength": "30"
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "订单状态："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.orderStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orderStatusId", $$v)
      },
      expression: "filters.orderStatusId"
    }
  }, _vm._l((_vm.statusoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "所属品牌商："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "options": _vm.optionsBrand,
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.pinpaishang),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pinpaishang", $$v)
      },
      expression: "filters.pinpaishang"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "20%"
    },
    attrs: {
      "label": "下单时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.value6,
      "editable": _vm.iseditable,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("订单管理")]), _vm._v(" "), (_vm.menuAction.indexOf(45) > -1) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showWatch()
      }
    }
  }, [_vm._v("导出Excel")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "订单编号",
      "width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.OrderNo,
            "label": scope.row.OrderNo
          }
        }, [_vm._v(_vm._s(scope.row.OrderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额",
      "width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.PaidPrice,
            "label": scope.row.PaidPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.PaidPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.PlaceOrderTime,
            "label": scope.row.PlaceOrderTime
          }
        }, [_vm._v(_vm._s(scope.row.PlaceOrderTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "支付时间",
      "width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.PayTime,
            "label": scope.row.PayTime
          }
        }, [_vm._v(_vm._s(scope.row.PayTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属品牌商",
      "width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.BbName,
            "label": scope.row.BbName
          }
        }, [_vm._v(_vm._s(scope.row.BbName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "管家佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.HkPrice,
            "label": scope.row.HkPrice
          }
        }, [_vm._v(_vm._s(scope.row.HkPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "共创佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.CcePrice,
            "label": scope.row.CcePrice
          }
        }, [_vm._v(_vm._s(scope.row.CcePrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.OrderStatusName,
            "label": scope.row.OrderStatusName
          }
        }, [_vm._v(_vm._s(scope.row.OrderStatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "action_container",
          on: {
            "click": function($event) {
              return _vm.seeSelectOrderDetailById(scope.row.Id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看\r\n              ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), (_vm.isOrderWatch) ? _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("订单管理查看")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "0 10px 0 0"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderdetail.OrderStatusId == 2),
      expression: "orderdetail.OrderStatusId == 2"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showEdit()
      }
    }
  }, [_vm._v("发货")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderdetail.OrderStatusId < 3),
      expression: "orderdetail.OrderStatusId < 3"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.confirmCancle()
      }
    }
  }, [_vm._v("取消订单")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "margin": "0 20px"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('span', {
      key: item.index,
      staticStyle: {
        "width": "33%",
        "display": "flex"
      }
    }, [_c('p', {
      staticClass: "watch_first",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "width": "85%",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "margin": "10px 0 20px 0"
    },
    attrs: {
      "data": _vm.detailList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "商品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.GoodsCode))])]
      }
    }], null, false, 3021030139)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Title))])]
      }
    }], null, false, 672660294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "颜色",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.ColorName))])]
      }
    }], null, false, 1570587196)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singleprice",
      "label": "单价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("￥" + _vm._s(scope.row.TzrPrice))])]
      }
    }], null, false, 4202712729)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Counts))])]
      }
    }], null, false, 2243692182)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PaidPrice",
      "label": "优惠券优惠金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("￥" + _vm._s(scope.row.CouponPrice))])]
      }
    }], null, false, 3364019821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CouponName",
      "label": "会员优惠金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("￥" + _vm._s(scope.row.VipDiscountPrice))])]
      }
    }], null, false, 484595735)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PaidPrice",
      "label": "实付",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("￥" + _vm._s(scope.row.PaidPrice))])]
      }
    }], null, false, 1468476857)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }], null, false, 711934197)
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "发货",
      "center": true,
      "visible": _vm.isOrderEdit,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isOrderEdit = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "dialogForm",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流方式:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.changeShow(_vm.form.LogisticsModeId)
      }
    },
    model: {
      value: (_vm.form.LogisticsModeId),
      callback: function($$v) {
        _vm.$set(_vm.form, "LogisticsModeId", $$v)
      },
      expression: "form.LogisticsModeId"
    }
  }, _vm._l((_vm.wuliu), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBusiness),
      expression: "isBusiness"
    }],
    staticClass: "pointer",
    attrs: {
      "label": "送货日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": _vm.iseditable,
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions1
    },
    model: {
      value: (_vm.form.DeliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "DeliveryDate", $$v)
      },
      expression: "form.DeliveryDate"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isThird),
      expression: "isThird"
    }],
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "label": "物流公司:",
      "prop": "name"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.LogisticsCompanyId),
      callback: function($$v) {
        _vm.$set(_vm.form, "LogisticsCompanyId", $$v)
      },
      expression: "form.LogisticsCompanyId"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isThird),
      expression: "isThird"
    }],
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "label": "物流单号:",
      "prop": "num"
    }
  }, [_c('el-input', {
    staticClass: "inner_input_group",
    attrs: {
      "placeholder": "请填写单号",
      "maxlength": "50",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.LogisticsNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "LogisticsNumber", $$v)
      },
      expression: "form.LogisticsNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.isOrderEdit = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52b57257!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/order.vue
// module id = 1691
// module chunks = 3